/**
 *
 * Styles for TabTitle
 *
 */

import styled, { css } from "styled-components";
import { key } from "styled-theme";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const ieTabListItem = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    width: 25%;

    @media screen and (min-width: ${breakpoints.tablet}) {
      width: inherit;
    }
  }
`;

export const TabListItem = styled.li`
  list-style: none;
  flex: 1 0 ${(props) => 100 / props.numberOfTabs}%;
  cursor: pointer;
  position: relative;
  border-top: var(--dui-size-width-border-xs) solid var(--dui-color-gray-500);
  transition: border-top 100ms ease-in-out;
  ${ieTabListItem}

  &.is-selected {
    border-top-color: transparent;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    min-width: 205px;
    flex: inherit;
  }

  &:last-child {
    border-left: 0;
  }

  @media print {
    display: none;
  }
`;

export const TabLinkStyled = styled.a`
  border-top: 5px solid transparent;
  transition: border-top 100ms ease-in-out;
  outline: none;
  width: 100%;
  height: 100%;
  text-align: ${(props) => props.headlineAlignment};
  font-weight: ${(props) => props.headlineFontWeight};
  text-decoration: none;
  color: var(--dui-color-black-500);
  padding: var(--dui-size-space-6x) var(--dui-size-space-3x);
  display: inline-flex;
  align-items: center;
  justify-content: ${(props) => props.headlineAlignment};
  font-size: ${key("fonts.mobile.tabs.size")};
  line-height: ${key("fonts.mobile.tabs.lineHeight")};
  background-color: var(--dui-color-black-opacity-05);

  /* Use parent's selected state since aria-selected is now on the parent */
  li[aria-selected="true"] & {
    color: var(--dui-color-red-500);
    border-top-color: var(--dui-color-red-500);
    background-color: var(--dui-color-white-500);
  }

  .tabLinkText {
    padding: var(--dui-size-space-2x) var(--gaq-size-space-3px)
      var(--dui-size-space-1);
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    font-size: ${key("fonts.desktop.tabs.size")};
    line-height: ${key("fonts.desktop.tabs.lineHeight")};
    text-align: center;
    padding: var(--dui-size-space-7x) var(--dui-size-space-10x);

    /* Let the parent handle focus, not the link */
    li:focus & .tabLinkText {
      background-color: var(--dui-color-red-500);
      color: var(--dui-color-white-500);
    }
  }

  ${(props) => props.extraStyles};
`;
